
import { Options, Vue } from 'vue-class-component';

@Options({
})
export default class App extends Vue {

  onInstall() {
    window.open("https://itunes.apple.com/app/id1614571372");
  }
}
